import {Box, FormControl, FormHelperText, Typography} from '@mui/material';
import SelectV2 from './SelectV2';
import {VersionVariants} from '@jobseeker/lotus/enums/variants';
import {LOCATIONS} from '../../constants';
import {CourseEnquiryPopupType} from './types';

const CurrentLocation = (props: CourseEnquiryPopupType) => {
  const {formik, theme, menuOpen, setMenuOpen} = props;

  const error =
    formik.touched.currentLocationCoursePage &&
    Boolean(formik.errors.currentLocationCoursePage);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        mt:
          formik.touched.currentOrganizationCoursePage &&
          formik.errors.currentOrganizationCoursePage?.length
            ? 0.875
            : 3,
        width: '100%',
      }}
    >
      <FormControl
        id="currentLocationCoursePage"
        key="currentLocationCoursePage"
        error={error}
        sx={{
          display: 'block',
          width: '100%',
        }}
      >
        <Typography
          sx={{
            color: '#333',
            fontSize: theme?.typography.pxToRem(14),
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '18px',
            mb: 1,
          }}
        >
          Current Location&#42;
        </Typography>
        <SelectV2
          menuOpen={menuOpen === 'currentLocationCoursePage'}
          setMenuOpen={setMenuOpen}
          variant={VersionVariants.VERSION_TWO}
          options={LOCATIONS}
          label={'Select your current location'}
          name="currentLocationCoursePage"
          key="currentLocationCoursePage"
          value={[formik.values.currentLocationCoursePage]}
          onChange={formik.handleChange}
          error={error}
          sx={{
            ...(error && {
              '& .MuiSelect-select': {
                border: '1px solid red',
              },
            }),
            maxWidth: 390,
          }}
        />
        {error && (
          <FormHelperText>
            {formik.errors.currentLocationCoursePage}
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
};

export default CurrentLocation;
